import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "components/ui/Button";
import Icon from "components/AppIcon";
import StatusIndicator from "components/ui/StatusIndicator";

export default function SuccessConfirmation({ volunteer }) {
  const navigate = useNavigate();

  return (
    <div className="text-center py-4 animate-fade-in">
      {/* Success Icon */}
      <div className="flex justify-center mb-4">
        <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-success/10 flex items-center justify-center">
          <Icon name="CheckCircle2" size={40} color="var(--color-success)" />
        </div>
      </div>
      <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground mb-2">
        Welcome, {volunteer?.name}!
      </h2>
      <p className="font-body text-sm md:text-base text-muted-foreground mb-4">
        You have successfully registered as a volunteer.
      </p>
      {/* Status Badge */}
      <div className="flex justify-center mb-6">
        <StatusIndicator status="new" size="lg" showTooltip={false} />
      </div>
      {/* Next Steps */}
      <div className="bg-muted rounded-lg p-4 text-left mb-6 space-y-3">
        <p className="font-caption text-sm font-semibold text-foreground flex items-center gap-2">
          <Icon name="ListChecks" size={16} color="var(--color-primary)" />
          Next Steps
        </p>
        {[
          { icon: "LayoutDashboard", text: "Visit your Dashboard to view your profile" },
          { icon: "BookOpen", text: "Browse the Training Catalog and enroll in courses" },
          { icon: "TrendingUp", text: "Complete training to advance your volunteer status" },
        ]?.map((step) => (
          <div key={step?.text} className="flex items-start gap-2">
            <Icon name={step?.icon} size={14} color="var(--color-primary)" className="mt-0.5 flex-shrink-0" />
            <p className="font-caption text-sm text-foreground">{step?.text}</p>
          </div>
        ))}
      </div>
      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <Button
          variant="default"
          size="lg"
          iconName="LayoutDashboard"
          iconPosition="left"
          onClick={() => navigate("/volunteer-dashboard")}
        >
          Go to Dashboard
        </Button>
        <Button
          variant="outline"
          size="lg"
          iconName="BookOpen"
          iconPosition="left"
          onClick={() => navigate("/training-courses-catalog")}
        >
          Browse Training
        </Button>
      </div>
    </div>
  );
}